// extracted by mini-css-extract-plugin
module.exports = {"dashWrapper":"MyDomains_dashWrapper__x7i6F","dashInner":"MyDomains_dashInner__LMIb-","sectionTitle":"MyDomains_sectionTitle__2krlx"};